import stylesheet from './x-splide.component.scss?as=stylesheet';
import {html, LitElement} from 'lit';
import {styleMap} from 'lit/directives/style-map.js';
import Splide from '@splidejs/splide';

export class SplideElement extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			type: {
				type: String
			},
			options: {
				type: Object
			}
		};
	}

	get mergedOptions () {
		return {
			...this._defaultOptions,
			...this.options
		};
	}

	get slides () {
		return Array.from(this.children)
			?.filter(child => child.nodeType === Node.ELEMENT_NODE);
	}

	constructor () {
		super();

		this.styles = {
			'margin-right': '0.5rem',
			width: 'calc(((100% + 0.5rem) / 5) - 0.5rem)'
		};

		this.type = '';

		this.splide = null;

		// Set private property values
		this._defaultOptions = {
			arrows: true,
			breakpoints: {
				640: {
					gap: 16,
					perPage: 2
				},
				960: {
					gap: 16,
					perPage: 3
				}
			},
			gap: 8,
			keyboard: 'focused',
			pagination: false,
			perPage: 4,
			rewind: true
		};

		// Set default property values
		this.options = [];
	}

	firstUpdated () {
		const options = this.mergedOptions;
		this.splide = new Splide(this.renderRoot.querySelector('.splide'), options);
		this.splide.mount();
	}

	async updateSlides () {
		await this.updateComplete;

		for (let i = 0; i < this.slides.length; i++) {
			this.slides[i].slot = i;
		}
	}

	updated () {
		super.updated();

		this.updateSlides();
	}

	render () {
		const splideClass = this.type ? 'x-' + this.slugify(this.type) : '';

		return html`
			<section class="splide ${splideClass}">
				<div class="splide__arrows x-splide__arrows splide__arrows--ltr">
					<button class="splide__arrow splide__arrow--prev x-splide__arrow--prev" type="button" aria-label="Go to last slide" aria-controls="splide02-track">
						<span class="splide__arrow--icon u-icon-chevron-left"></span>
					</button>
					<button class="splide__arrow splide__arrow--next x-splide__arrow--next" type="button" aria-label="Next slide" aria-controls="splide02-track">
					<span class="splide__arrow--icon u-icon-chevron-right"></span>
					</button>
				</div>
				<div class="splide__track">
					<ul class="splide__list">
						${this.slides?.map((_, i) => html`<li class="splide__slide" style="${styleMap(this.styles)}"><slot name="${i}"></slot></li>`)}
					</ul>
				</div>
			</section>
		`;
	}

	/**
	 * Slugify a string
	 * @param {String} text
	 * @returns {void}
	 */
	slugify (text) {
		return text.toLowerCase().replace(/[^\w ,-]+/g, '').replace(/ +/g, '-');
	};
};

window.customElements.define('x-splide', SplideElement);
